import { createAction, props } from '@ngrx/store';

import BetslipActions from '../base/store/actions';
import { IBetslipSourcePageState } from '../model/edit-mybet/edit-bet-init';

export class BetslipSourcePageActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/source_page`;

    private static readonly SET_SOURCE_PAGE = `${BetslipSourcePageActions.ACTION_SCHEMA}/SET_SOURCE_PAGE`;

    static setSourcePage = createAction(BetslipSourcePageActions.SET_SOURCE_PAGE, props<{ payload: IBetslipSourcePageState }>());
}
